import { ls } from '@/CommonVueCore/src/services/secureLs/secure';
import { defineStore } from 'pinia';

export const useLangStore = defineStore('langStore', {
    state: () => ({
        lang: null
    }),
    getters: {
        getLangInfo() {
            return this.lang;
        },
    },
    actions: {
        setLangInfo(_lang) {
            this.lang =_lang;
        },
        setResetLang() {
            this.lang = null
        },
    },
    persist: {
        storage: {
            getItem: function (key) {
                try {
                    return ls.get(key);
                }
                catch (err) {
                    alert("hata var clear edecek")
                    localStorage.clear();
                }
            },
            setItem: (key, value) => ls.set(key, value),
            removeItem: (key) => ls.remove(key)
        }
    }
});

